import React from 'react';
import {
    Text,
    Center,

  } from "@chakra-ui/react";

const Placeholder = () => {
  return (
    <Center height='50vh'>
        <Text fontSize='5xl' align={'center'} w='66%'>
        The National Medalists are coming soon!
        </Text>
    </Center>
  )
}

export default Placeholder